
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RegistroPontoDisplay extends Vue {
  //#region [ PROPS ]
  @Prop({ default: false })
  readonly fullscreen: boolean;

  @Prop({ default: '' })
  readonly pin: string;
  //#endregion



  //#region [ STORE ]
  get isOffline():boolean {
    return this.$store.state.isOffline;
  }
  //#endregion



  //#region [ DATA ]
  showDashes: boolean = false;
  dashTimeout: number | null = null;
  reconhecimentoLiberado: boolean = false;
  //#endregion


  //#region [ COMPUTED ]
  get showExtraActions(): boolean {
    return !this.showDashes && this.pin.length === 0;
  }

  get fullscreenIcon(): string {
    return this.fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen';
  }
  //#endregion



  //#region [ EVENTS ]
  @Emit('rec-facial-btn-clicked')
  emitRecFacialBtnClicked(): void {}

  @Emit('qr-code-btn-clicked')
  emitQrCodeBtnClicked(): void {}

  @Emit('fullscreen-btn-clicked')
  emitFullscreenBtnClicked(): void {}
  //#endregion



  //#region [ LIFECYCLE ]
  created(): void {
    this.getTravaReconhecimento();
  }

  beforeDestroy() {
    if (this.dashTimeout !== null) {
      clearTimeout(this.dashTimeout);
    }
  }
  //#endregion



  //#region [ METHODS ]
  blinkDashes() {
    if (this.showDashes) {
      return;
    }

    this.showDashes = true;
    window.setTimeout(() => this.showDashes = false, 1000);
  }

  private async getTravaReconhecimento() {
    const valorReferencia = await CommonRequests.getValorReferencia('FAZ_RECONHECIMENTO');
    this.reconhecimentoLiberado = valorReferencia === '1';
  }
  //#endregion
}
